<template>
    <div>
        <div class="tab-header">
            Miete
        </div>

        <ul class="nav nav-tabs"
            id="myTab"
            role="tablist">
            <li v-for="(year, index) in this.getYears"
                class="nav-item"
                role="presentation">
                <button class="nav-link"
                    :class="index == 0 ? 'active': ''"
                    :id="getYearButtonId(year)"
                    data-toggle="tab"
                    :data-target="getTarget(year)"
                    type="button"
                    role="tab"
                    :aria-controls="year"
                    :aria-selected="index == 0 ? true : false">{{year}}</button>
            </li>

        </ul>
        <div class="tab-content"
            id="priceTabContent">
            <div v-for="(year, index) in this.getYears"
                class="tab-pane fade"
                :class="index == 0 ? 'show active' : ''"
                :id="getTabId(year)"
                role="tabpanel"
                :aria-labelledby="getTabAreaLabel(year)">
                <table class="table pricelist table-hover">
                    <thead>
                        <tr class="subrow">
                            <th>Saison</th>
                            <th>Zeitraum</th>
                            <th class="text-center">Preis</th>
                            <!--<th>&nbsp;</th>
                            <th>&nbsp;</th>-->
                        </tr>
                    </thead>
                    <tbody v-for="sg in priceArray">
                        <tr v-for="price in sg.lines"
                            v-if="sg.service.type=='RENT' && isDateInRange(price.fromdate, year)"
                            class="subrow">
                            <td class="subinfo">
                                <span>{{price.season}}</span>
                                <br/>
                            </td>
                            <td><span v-if="price.fromdate">{{getFormattedDate(price.fromdate)}} - {{getFormattedDate(price.tilldate)}}</span></td>
                            <td class="text-center">
                                <span>ab {{getCalculatedPrice(price.value)}}</span>
                            </td>
                            <!--<td>
                                <span v-if="sg.service.type == 'RENT' && sg.nightRange && sg.nightRange.min">
												{{sg.nightRange.min}} Nächte
  										  </span>
                            </td>
                            <td>
                                jede weitere Nacht ab {{price.value / 100}} €
                            </td>-->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="notice">
            Änderungen möglich
        </div>

    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'price-tab',
    	props: {
    		pricelist: String,
    		uniqueid: String
    	},
    	data: function() {
    		return {
    			priceArray: {},
    			unitId: Number,
    			priceBookingFee: Number,
    			priceFinalCleaning: Number
    		};
    	},
    	mounted: function() {
    		var pricelist = JSON.parse(this.pricelist);
    		this.priceArray = pricelist;

    		//console.log('Pricelist::', pricelist);
    		var years = [];

    		var i, j;
    		for (i = 0; i < pricelist.length; i++) {
    			if (pricelist[i].service.type && pricelist[i].service.type === 'FINALCLEANING') {
    				console.log('Type::', pricelist[i].service.type, 'Price::', pricelist[i].price);
    				this.priceFinalCleaning = pricelist[i].price;
    			}
    			if (pricelist[i].service.type && pricelist[i].service.type === 'BOOKING_FEE') {
    				console.log('Type::', pricelist[i].service.type, 'Price::', pricelist[i].price);
    				this.priceBookingFee = pricelist[i].price;
    			}
    			for (j = 0; j < pricelist[i].lines.length; j++) {
    				//console.log('inside loop date::' + pricelist[i].lines[j].fromdate);
    				if (pricelist[i].lines[j].fromdate) {
    					var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    					//console.log('year is::' + year);
    					if (years.indexOf(year) < 0) {
    						years.push(year);
    					}
    				}
    			}
    		}
    		//	console.log('years::' + years);
    		/*console.log('this.pricelist::' + this.pricelist); */
    	},
    	methods: {
    		getUniqueId: function() {
    			console.log('getUniqueId::' + this.uniqueid);
    			return this.uniqueid;
    		},
    		getYearButtonId: function(year) {
    			return 't' + year + '-tab' + this.getUniqueId();
    		},
    		getTarget: function(year) {
    			return "#t" + year + this.getUniqueId();
    		},
    		getTabId: function(year) {
    			return "t" + year + "" + this.getUniqueId();
    		},
    		getTabAreaLabel: function(year) {
    			return "t" + year + "-tab" + this.getUniqueId();
    		},
    		getFormattedDate: function(date) {
    			return DateEx.formatDate(date, 'dd.MM.yy', 'de');
    		},
    		getCalculatedPrice: function(price) {
    			var rentPrice = 0;
    			var calcPrice = 0;
    			if (price > 0) {
    				//rentPrice = price * 7;
    				calcPrice = Number(price / 100).toLocaleString("de-DE", {
    					minimumFractionDigits: 2
    				}) + " € pro Nacht";
    			}
    			return calcPrice;
    		},
    		isDateInRange: function(fromdate, year) {
    			if (!fromdate) {
    				return true;
    			}
    			var fromYear = parseInt(fromdate.substring(0, 4));
    			if (fromYear == year) {
    				return true;
    			}
    			return false;
    		}

    	},
    	computed: {
    		getYears: function() {
    			var pricelist = JSON.parse(this.pricelist);

    			console.log('Pricelist::', pricelist);
    			var years = [];
    			var today = new Date();
    			var currentYear = today.getFullYear();
    			var i, j;
    			for (i = 0; i < pricelist.length; i++) {
    				for (j = 0; j < pricelist[i].lines.length; j++) {
    					if (pricelist[i].lines[j].fromdate) {
    						var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    						console.log('year::' + year);
    						console.log('currentYear::' + currentYear);
    						if (years.indexOf(year) < 0 && parseInt(year) <= (parseInt(currentYear) + 1)) {
    							console.log('adding year');
    							years.push(year);
    						}
    					}
    				}
    			}
    			return years;
    		}
    	}
    };
</script>